import Icon from '@/icons';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Team } from 'types';

export const SettingsTeamEmojis = ({ me, team, user }: { me: any, team: Team, user: any }) => {

    const getEmojis = useQuery({
        queryKey: ['emojis', team.id],
        queryFn: async () => {
            const res = await fetch(`__SITE_BASE__/api/teams/${team.id}/reactions`);
            const data = await res.json();
            return data.reactions || [];
        },
        retry: 1,
        retryDelay: 1000,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    });

    const createEmoji = async () => {
        const file = document.getElementById('file') as HTMLInputElement;
        file.click();

        file.onchange = async () => {
            const formData = new FormData();
            formData.append('emoji', file.files![0]);
            formData.append('name', file.files![0].name.split('.')[0]);
            const res = await fetch(`__SITE_BASE__/api/teams/${team.id}/reactions`, {
                method: 'POST',
                body: formData
            });

            const data = await res.json();
            if (res.ok) getEmojis.refetch();
        }
    }

    return (
        <div className="flex flex-col items-start w-full focus:outline-none space-y-24">
            <div className='flex flex-col items-start w-full'>
                <input type="file" className='hidden' id='file' accept='image/webp, image/png, image/gif' multiple={false} />

                <div className='flex flex-col w-full items-start gap-2 mt-4'>
                    <button
                        onClick={createEmoji}
                        className='flex items-center gap-2 justify-center bg-brand-dark text-gray-200 rounded-lg px-2 py-1 hover:bg-brand-darkest hover:text-white'
                    >
                        <Icon name='plus' />
                        <span>Create Emoji</span>
                    </button>

                    <h3 className='text-gray-400 text-sm'>The names must only contain alphanumeric characters and underscores</h3>
                </div>

                <div className='w-full mt-4 overflow-auto'>
                    <table className='w-full text-left text-gray-200'>
                        <thead className='border-b border-gray-600'>
                            <tr>
                                <th className='text-gray-400 w-[500px] sm:w-1/2 py-2'>Emoji</th>
                                <th className='text-gray-400 py-2'>Added At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!getEmojis.isFetching && getEmojis.data?.map((emoji: any, index: number) => (
                                <tr key={index} className='border-b border-gray-600'>
                                    <td className='min-w-32 h-12 p-2 gap-2 sm:flex sm:flex-row flex-col items-center'>
                                        <div className='relative min-w-8 group items-center justify-center'>
                                            <div className='absolute flex items-center justify-center w-full h-full bg-black bg-opacity-50 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                                                <button
                                                    onClick={async () => {
                                                        const res = await fetch(`__SITE_BASE__/api/teams/${team.id}/reactions/${emoji.id}`, {
                                                            method: 'DELETE'
                                                        });
                                                        if (res.ok) getEmojis.refetch();
                                                    }}
                                                    className='text-red-400 rounded-lg hidden group-hover:flex'
                                                >
                                                    <Icon name='delete' size={"16px"} />
                                                </button>
                                            </div>
                                        <img src={emoji.url} alt={emoji.name} className='w-8 h-8 object-cover rounded-lg' loading='lazy' />
                                        </div>
                                        <td className='flex items-center gap-2 '>
                                            <span className='text-gray-400'>:</span>
                                            <span
                                                contentEditable
                                                suppressContentEditableWarning
                                                onInput={(e) => {
                                                    const text = e.currentTarget.textContent;
                                                    const newText = text?.replace(/\s/g, '_')?.replace(/[^a-zA-Z0-9_]/g, '');
                                                    e.currentTarget.textContent = String(newText).slice(0, 32);
                                                }}
                                                className="hover:border-0 border-b border-transparent focus:border-brand-dark focus:outline-none"
                                                onBlur={async (e) => {
                                                    const newName = e.currentTarget.textContent;
                                                    if (!newName) return e.currentTarget.textContent = emoji.name;
                                                    if (newName !== emoji.name && newName) {
                                                        const res = await fetch(`__SITE_BASE__/api/teams/${team.id}/reactions/${emoji.id}`, {
                                                            method: 'PUT',
                                                            headers: {
                                                                'Content-Type': 'application/json',
                                                            },
                                                            body: JSON.stringify({ name: String(newName).slice(0, 32) })
                                                        });
                                                        if (res.ok) getEmojis.refetch();
                                                    }
                                                }}
                                            >
                                                {emoji.name}
                                            </span>
                                            <span className='text-gray-400'>:</span>
                                        </td>

                                    </td>

                                    <td className='text-white'>
                                        <div className="flex items-center justify-start">
                                            {new Date(emoji.createdAt).toLocaleString()}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
